import ClivageWorkspace from '../features/clivages/layouts/workspace';

// TSS vite/01 §"Pages are thin". Full-screen clivage workspace (own tab),
// opened from an OPU session's "Clivage" action. Gated in app.jsx.
export default function ClivageSessionPage() {
    return <ClivageWorkspace />;
}
